import { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLongPress } from 'use-long-press';

import DimesionPage from 'pages/PlanPageDetailsOPZ/Inputs/DimensionPage';
import IndicatorPageMultiDim from 'pages/PlanPageDetailsOPZ/Inputs/IndicatorPageMultiDim';
import { getSelectedDriver } from 'redux/PlanPageSlice';

import { usePlanPageUiRevamp } from '../usePlanPageUiRevamp';

import RevampOrganisationPanel from './RevampOrganisationPanel';

interface Properties {
  refetchRequest: () => void;
}

/**
 * Revamp inputs shell — only organisation (org chart + table) uses new UI.
 * Indicator and property drivers keep legacy panels.
 */
const RevampInputSection = ({ refetchRequest }: Properties) => {
  const isRevampEnabled = usePlanPageUiRevamp();
  const [isLongClicked, setIsLongClicked] = useState(false);
  const currentDriver = useSelector(getSelectedDriver);

  const longClickCheck = useLongPress(() => {
    setIsLongClicked((previousState) => !previousState);
  });

  if (!isRevampEnabled) {
    return null;
  }

  const onDataChange = () => refetchRequest();

  if (currentDriver?.type === 'dimension') {
    return (
      <RevampOrganisationPanel
        longClickCheck={longClickCheck}
        isLongClicked={isLongClicked}
        refetchRequest={refetchRequest}
      />
    );
  }

  if (currentDriver?.type === 'indicator') {
    return <IndicatorPageMultiDim refetchRequest={onDataChange} />;
  }

  return <DimesionPage refetchRequest={onDataChange} />;
};

export default memo(RevampInputSection);
